import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Home from '../pages/Home';
// import Login from '../pages/Login';
// import Signup from '../pages/Signup';
// import Dashboard from '../pages/Dashboard';
import TestForm from '../pages/TestForm';
import ApiTester from '../pages/ApiTester';
import MainForm from '../pages/MainForm';
import BaseLayout from '../pages/BaseLayout';
import ParticipantForm from '../pages/ParticipantForm';
import EmergencyContactForm from '../pages/EmergencyContactForm';
import MountainForm from '../pages/MountainForm';
import { EMERGENCY_CONTACT_FIELDS } from '../utils/formConfig';
import RegistrationComplete from '../pages/RegistationComplete';
import MainMountain from '../pages/MainMountain';
import MainLanding from '../pages/landingApp/MainLanding';
import LoginPage from '../pages/landingApp/Login';
import Dashboard from '../pages/landingApp/Dashboard';
import PrivateRoute from './PrivateRoutes';
import { AuthProvider } from '../utils/session/AuthContext';
import Profile from '../pages/landingApp/Profile';
import Notifications from '../pages/landingApp/Notifications';
import Agenda from '../pages/landingApp/Agenda';
import LiftPass from '../pages/landingApp/LiftPass';
import General from '../pages/landingApp/General';
// import Directorio from '../pages/landingApp/Directorio';
// import Experiences from '../pages/landingApp/Experiences';
import Recomendations from '../pages/landingApp/Recomendations';
import ExternalRedirect from '../utils/externalRedirection/ExternalRedirect';
// import Weather from '../pages/landingApp/Weather';
import PersonalData from '../pages/landingApp/PersonalData';
import FlightsData from '../pages/landingApp/FlightData';
import ResetPassword from '../pages/landingApp/ResetPassword';
import Rankings from '../pages/landingApp/Rankings';
import Login from '../pages/landingApp/Login';


const Experiences = React.lazy(() => import('../pages/landingApp/Experiences'));
const Directorio = React.lazy(() => import('../pages/landingApp/Directorio'));
const Weather = React.lazy(() => import('../pages/landingApp/Weather'));

const AppRoutes = () => {
  return (
  <AuthProvider>
    <Router>
      <React.Suspense fallback={<div style={{ padding: 20 }}>Loading...</div>}>
      <Routes>
        {/* <Route path="/" element={<LoginPage />} /> */}
        <Route path="/" element={<Dashboard />} />
        <Route path="/login" element={<Login />} />
        <Route path="/testForm" element={<TestForm />} />
        <Route path="/api-test" element={<ApiTester />} />
        <Route path="/registration" element={<BaseLayout />} />
        <Route path="/test" element={<MountainForm />} />
        <Route path="/profile" element={<Profile/>} />
        <Route path="/notifications" element={<Notifications />} />
        <Route path="/agenda" element={<Agenda />} />
        {/* <Route path="/loginCopa" element={<LoginPage />} /> */}
        <Route path="/liftPass" element={<LiftPass />} />
        <Route path="/menu" element={<General />} />
        <Route path="/directorio" element={<Directorio />} />
        <Route path="/recomendations" element={<Recomendations />} />
        <Route path="/experiences" element={<Experiences />} />
        <Route path="/weather" element={<Weather />} />
        <Route path="/links" element={<ExternalRedirect />} />
        {/* <Route path="/landing" element={<Dashboard />} /> */}
        <Route path="/personalData" element={<PersonalData />} />
        {/* <Route path="/tickets" element={<Tickets />} /> */}
        <Route path="/rankings" element={<Rankings />} />
        <Route path="/flightsData" element={<FlightsData />} />
        <Route path="/reset-new-password/:uid/:token" element={<ResetPassword />} />
        


          {/* <Route path="/landing" element={
            <PrivateRoute>
              <Dashboard />

            </PrivateRoute>
            }
          /> */}
        
        {/* <Route path="/dashboard" element={<Dashboard />} /> */}
        {/* Debug: show unmatched paths and current pathname */}
        <Route
          path="*"
          element={<DebugNotFound />}
        />
      </Routes>
      </React.Suspense>
    </Router>
  </AuthProvider>
  );
};

function DebugNotFound() {
  const loc = useLocation();
  return (
    <div style={{ padding: 20 }}>
      <h3>No client route matched</h3>
      <p>Current pathname: {loc.pathname}</p>
      <p>
        If this shows for <code>/testForm</code>, the router isn't matching — check
        the exact path casing and that the bundle is up-to-date.
      </p>
    </div>
  );
}

export default AppRoutes;
